import { CortexSetting, LocationVarKey } from "@swivl-mono/types";

import { CortexSettingRow } from "../../Components/CortexSettingRow";
import { TopicCard } from "../../Components/TopicCard";

export const TOPIC_VARS: LocationVarKey[] = [LocationVarKey.CortexEscalationPushbackMode];

// ENG-3390 (Chuck, 2026-09-28) — moved here from the per-routing-group flyout on
// Escalation & Ticketing. Option labels are Chuck's (2026-09-18).
const PUSHBACK_MODE_SETTING: CortexSetting = {
  kind: "select",
  key: "escalationPushbackMode",
  varKey: LocationVarKey.CortexEscalationPushbackMode,
  label: "Before connecting a caller to the team",
  description: "Applies to every group. Frustrated callers, emergencies and sensitive situations always connect right away.",
  options: [
    { value: "connect-right-away", label: "Connect right away" },
    { value: "offer-help-once", label: "Offer to help once" },
    { value: "offer-help-once-unless-frustrated", label: "Offer to help once unless the customer is frustrated" }
  ],
  default: "offer-help-once-unless-frustrated"
};

export function EscalationPushbackTopic(): React.ReactElement {
  return (
    <TopicCard title="Before Connecting a Caller" description="Offer to help once before connecting a caller to the team.">
      <CortexSettingRow setting={PUSHBACK_MODE_SETTING} layout="horizontal" />
    </TopicCard>
  );
}
